import React from "react"
export const PopupButton = ({ type, name, onClick, disabled }) => (
	<a className={`button ${type}`} onClick={onClick} disabled={disabled}>
		{name}
	</a>
)
